import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';

const supportedActions = [
  'ADD_NEW_POST',
  'LOAD_POSTS',
  'LOAD_NEW_POSTS',
  'LOAD_OLDER_POSTS',
  'LOAD_POSTS_PREVIEW',
  'LOAD_OLDER_POSTS_PREVIEW',
  'DELETE_POST',
  'RESTORE',
  'EDIT_POST',
  'POST_LIKE_CHANGED',
  'POST_COMMENTS_CHANGED',
  'REMOVE_NEW_POST_STATUS',
];

export const consts = createConsts(
  'communities',
  'postsList',
  ...supportedActions,
);
export const actions = createActions(consts);

const deletePost = (state, payload) => {
  const index = state.findIndex(i => i.id === parseInt(payload.id, 10));

  return [...state.slice(0, index), ...state.slice(index + 1)];
};

const editPost = (state, payload) => {
  const index = state.findIndex(i => i.id === payload.id);
  // eslint-disable-next-line no-param-reassign
  payload.forceFetchImage = true;

  return [...state.slice(0, index), payload, ...state.slice(index + 1)];
};

const changeLike = (state, payload) => {
  const { liked } = payload;
  const change = liked ? 1 : -1;
  const index = state.findIndex(i => i.id === payload.postId);

  if (index === -1) return state;

  const post = Object.assign({}, state[index], {
    liked,
    totalLikes: state[index].totalLikes + change,
  });

  return [...state.slice(0, index), post, ...state.slice(index + 1)];
};

const removeNewPostStatus = (state, payload) => {
  const id = payload;
  const newState = state.map(item => {
    if (item.id === id) {
      return {
        ...item,
        isNewPost: false,
      };
    }
    return item;
  });
  return [...newState];
};

const changeComments = (state, payload) => {
  const { change, postId } = payload;
  const index = state.findIndex(i => i.id === postId);

  if (index === -1) return state;

  const post = Object.assign({}, state[index], {
    totalComments: state[index].totalComments + change,
  });

  return [...state.slice(0, index), post, ...state.slice(index + 1)];
};

const reducer = (state = [], action) => {
  const { payload, type } = action;
  switch (type) {
    case consts.ADD_NEW_POST:
      return [...payload, ...state];
    case consts.LOAD_OLDER_POSTS:
      return [...state, ...payload];
    case consts.LOAD_NEW_POSTS:
      return [...payload, ...state];
    case consts.LOAD_POSTS:
    case consts.LOAD_POSTS_PREVIEW:
      return payload;
    case consts.LOAD_OLDER_POSTS_PREVIEW:
      return [...state, ...payload];
    case consts.DELETE_POST:
      return deletePost(state, payload);
    case consts.EDIT_POST:
      return editPost(state, payload);
    case consts.RESTORE:
      return [];
    case consts.POST_LIKE_CHANGED:
      return changeLike(state, payload);
    case consts.POST_COMMENTS_CHANGED:
      return changeComments(state, payload);
    case consts.REMOVE_NEW_POST_STATUS:
      return removeNewPostStatus(state, payload);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/communities/postsList.js